/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

// ------------------------------------
// Constants
// ------------------------------------

const initialState = {
  showLoading: false,
  dashboard: false,
  businessSponsorManage: false,
  userManagement: false,
  home: true,
  calendar: false,
  survey: false,
  activtiy: false,
  redeem: false,
  statement: false,
  qrcodeScan: false,
  chat: false,
  profile: false,
  adminSocieties: false,
  adminSponsors: false,
  events: [] as any[],
  eventsPage: 1,
  eventsLength: "",
  monthlyEvents: [] as any[],
  surveys: [] as any[],
  surveysPage: 1,
  surveysLength: "",
  surveyStatistics: [] as any[],
  surveyStatisticsPage: 1,
  surveyStatisticsLength: "",
  completedSurveys: [] as any[],
  completedSurveysPage: 1,
  completedSurveysLength: "",
  searchEvents: [] as any[],
  searchEventsPage: 1,
  searchEventsLength: "",
  followingOrganizers: [] as any[],
  followingOrganizersPage: 1,
  followingOrganizersLength: "",
  activityLists: [] as any[],
  activityListsLength: "",
  joiningActivityLists: [] as any[],
  joiningActivityListsLength: "",
  createdActivityLists: [] as any[],
  createdActivityListsLength: "",
  coupons: [] as any[],
  couponsLength: "",
  couponsPage: 1,
  createdCoupons: [] as any[],
  createdCouponsLength: "",
  createdCouponsPage: 1,
  redeemedCoupons: [] as any[],
  redeemedCouponsLength: "",
  redeemedCouponsPage: 1,
  posts: [] as any[],
  postsLength: "",
  postsPage: 1,
  redeemedSponsors: [] as any[],
  redeemedSponsorsLength: "",
  redeemedSponsorsPage: 1,
  sponsors: [] as any[],
  sponsorsLength: "",
  sponsorsPage: 1,
  following: 0,
  subscripted: 0,
  subscriptedEvents: [] as any[],
  subscriptedEventsPage: 1,
  subscriptedEventsLength: "",
  members: [] as any[],
  filterSociety: [] as any[],
  search: false,
  activityPage: 1,
  joiningActivityPage: 1,
  createdActivityPage: 1,
};

// ------------------------------------
// Slice
// ------------------------------------

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    controlLoading: (state, { payload }) => {
      state.showLoading = payload.showLoading;
    },
    controlTabBar: (state, { payload }) => {
      state.dashboard = payload.dashboard;
      state.userManagement = payload.userManagement;
      state.home = payload.home;
      state.calendar = payload.calendar;
      state.survey = payload.survey;
      state.activtiy = payload.activtiy;
      state.redeem = payload.redeem;
      state.businessSponsorManage = payload.businessSponsorManage;
      state.qrcodeScan = Boolean(payload.qrcodeScan ?? payload.statement);
      state.statement = false;
      state.chat = payload.chat;
      state.profile = payload.profile;
      state.adminSocieties = payload.adminSocieties ?? false;
      state.adminSponsors = payload.adminSponsors ?? false;
    },
    getEvents: (state, { payload }) => {
      state.events = payload.events;
      state.eventsLength = payload.eventsLength;
    },
    countEventsPage: (state, { payload }) => {
      state.eventsPage = payload.eventsPage;
    },
    resetEventsState: (state) => {
      state.events = initialState.events;
      state.eventsLength = initialState.eventsLength;
      state.eventsPage = initialState.eventsPage;
    },
    getMonthlyEvents: (state, { payload }) => {
      state.monthlyEvents = payload.monthlyEvents;
    },
    getSurveys: (state, { payload }) => {
      state.surveys = payload.surveys;
      state.surveysLength = payload.surveysLength;
    },
    countSurveysPage: (state, { payload }) => {
      state.surveysPage = payload.surveysPage;
    },
    resetSurveysState: (state) => {
      state.surveys = initialState.surveys;
      state.surveysLength = initialState.surveysLength;
      state.surveysPage = initialState.surveysPage;
    },
    getSurveyStatistics: (state, { payload }) => {
      state.surveyStatistics = payload.surveyStatistics;
      state.surveyStatisticsLength = payload.surveyStatisticsLength;
    },
    resetSurveyStatisticsState: (state) => {
      state.surveyStatistics = initialState.surveyStatistics;
      state.surveyStatisticsLength = initialState.surveyStatisticsLength;
      state.surveyStatisticsPage = initialState.surveyStatisticsPage;
    },
    getCompletedSurveys: (state, { payload }) => {
      state.completedSurveys = payload.completedSurveys;
      state.completedSurveysLength = payload.completedSurveysLength;
    },
    countCompletedSurveysPage: (state, { payload }) => {
      state.completedSurveysPage = payload.completedSurveysPage;
    },
    resetCompletedSurveysState: (state) => {
      state.completedSurveys = initialState.completedSurveys;
      state.completedSurveysLength = initialState.completedSurveysLength;
      state.completedSurveysPage = initialState.completedSurveysPage;
    },
    getSearchedEvents: (state, { payload }) => {
      state.searchEvents = payload.searchEvents;
      state.searchEventsLength = payload.searchEventsLength;
    },
    countSearchedEventsPage: (state, { payload }) => {
      state.searchEventsPage = payload.searchEventsPage;
    },
    resetSearchedEventsState: (state) => {
      state.searchEvents = initialState.searchEvents;
      state.searchEventsLength = initialState.searchEventsLength;
      state.searchEventsPage = initialState.searchEventsPage;
    },
    getFollowingOrganizers: (state, { payload }) => {
      state.followingOrganizers = payload.followingOrganizers;
      state.followingOrganizersLength = payload.followingOrganizersLength;
    },
    resetFollowingOrganizersState: (state) => {
      state.followingOrganizers = initialState.followingOrganizers;
      state.followingOrganizersLength = initialState.followingOrganizersLength;
      state.followingOrganizersPage = initialState.followingOrganizersPage;
    },
    getSubscriptedEvents: (state, { payload }) => {
      state.subscriptedEvents = payload.subscriptedEvents;
      state.subscriptedEventsLength = payload.subscriptedEventsLength;
    },
    countSubscriptedEventsPage: (state, { payload }) => {
      state.subscriptedEventsPage = payload.subscriptedEventsPage;
    },
    resetSubscriptedEventsState: (state) => {
      state.subscriptedEvents = initialState.subscriptedEvents;
      state.subscriptedEventsLength = initialState.subscriptedEventsLength;
      state.subscriptedEventsPage = initialState.subscriptedEventsPage;
    },
    getMembers: (state, { payload }) => {
      state.members = payload.members;
    },
    callActivityListsAPI: (state, { payload }) => {
      state.activityLists = payload.activityLists;
      state.activityListsLength = payload.activityListsLength;
      state.activityPage = payload.activityPage;
    },
    resetActivityListsState: (state) => {
      state.activityLists = initialState.activityLists;
      state.activityListsLength = initialState.activityListsLength;
      state.activityPage = initialState.activityPage;
    },
    callJoiningActivityListsAPI: (state, { payload }) => {
      state.joiningActivityLists = payload.joiningActivityLists;
      state.joiningActivityListsLength = payload.joiningActivityListsLength;
      state.joiningActivityPage = payload.joiningActivityPage;
    },
    resetJoiningActivityListsState: (state) => {
      state.joiningActivityLists = initialState.joiningActivityLists;
      state.joiningActivityListsLength = initialState.joiningActivityListsLength;
      state.joiningActivityPage = initialState.joiningActivityPage;
    },
    callCreatedActivityListsAPI: (state, { payload }) => {
      state.createdActivityLists = payload.createdActivityLists;
      state.createdActivityListsLength = payload.createdActivityListsLength;
      state.createdActivityPage = payload.createdActivityPage;
    },
    resetCreatedActivityListsState: (state) => {
      state.createdActivityLists = initialState.createdActivityLists;
      state.createdActivityListsLength = initialState.createdActivityListsLength;
      state.createdActivityPage = initialState.createdActivityPage;
    },
    callCouponsAPI: (state, { payload }) => {
      state.coupons = payload.coupons;
      state.couponsLength = payload.couponsLength;
    },
    countCouponsPage: (state, { payload }) => {
      state.couponsPage = payload.couponsPage;
    },
    resetCouponsState: (state) => {
      state.coupons = initialState.coupons;
      state.couponsLength = initialState.couponsLength;
      state.couponsPage = initialState.couponsPage;
    },
    callRedeemedCouponsAPI: (state, { payload }) => {
      state.redeemedCoupons = payload.redeemedCoupons;
      state.redeemedCouponsLength = payload.redeemedCouponsLength;
    },
    countRedeemedCouponsPage: (state, { payload }) => {
      state.redeemedCouponsPage = payload.redeemedCouponsPage;
    },
    resetRedeemedCouponsState: (state) => {
      state.redeemedCoupons = initialState.redeemedCoupons;
      state.redeemedCouponsLength = initialState.redeemedCouponsLength;
      state.redeemedCouponsPage = initialState.redeemedCouponsPage;
    },
    callPostsAPI: (state, { payload }) => {
      state.posts = payload.posts;
      state.postsLength = payload.postsLength;
    },
    countPostsPage: (state, { payload }) => {
      state.postsPage = payload.postsPage;
    },
    resetPostsState: (state) => {
      state.posts = initialState.posts;
      state.postsLength = initialState.postsLength;
      state.postsPage = initialState.postsPage;
    },
    callRedeemedSponsorsAPI: (state, { payload }) => {
      state.redeemedSponsors = payload.redeemedSponsors;
      state.redeemedSponsorsLength = payload.redeemedSponsorsLength;
    },
    countRedeemedSoponsorsPage: (state, { payload }) => {
      state.redeemedSponsorsPage = payload.redeemedSponsorsPage;
    },
    resetRedeemedSponsorsState: (state) => {
      state.redeemedSponsors = initialState.redeemedSponsors;
      state.redeemedSponsorsLength = initialState.redeemedSponsorsLength;
      state.redeemedSponsorsPage = initialState.redeemedSponsorsPage;
    },
    callSponsorsAPI: (state, { payload }) => {
      state.sponsors = payload.sponsors;
      state.sponsorsLength = payload.sponsorsLength;
    },
    countSoponsorsPage: (state, { payload }) => {
      state.sponsorsPage = payload.sponsorsPage;
    },
    resetSponsorsState: (state) => {
      state.sponsors = initialState.sponsors;
      state.sponsorsLength = initialState.sponsorsLength;
      state.sponsorsPage = initialState.sponsorsPage;
    },
    setSearch: (state, { payload }) => {
      state.search = payload.search;
    },
    countFollowing: (state, { payload }) => {
      state.following = payload.following;
    },
    countSubscripted: (state, { payload }) => {
      state.subscripted = payload.subscripted;
    },
  },
});

export const {
  controlLoading,
  controlTabBar,
  getEvents,
  countEventsPage,
  resetEventsState,
  getMonthlyEvents,
  getSurveys,
  countSurveysPage,
  resetSurveysState,
  getSurveyStatistics,
  resetSurveyStatisticsState,
  getCompletedSurveys,
  countCompletedSurveysPage,
  resetCompletedSurveysState,
  getSearchedEvents,
  countSearchedEventsPage,
  resetSearchedEventsState,
  getFollowingOrganizers,
  resetFollowingOrganizersState,
  getSubscriptedEvents,
  countSubscriptedEventsPage,
  resetSubscriptedEventsState,
  getMembers,
  callActivityListsAPI,
  resetActivityListsState,
  callJoiningActivityListsAPI,
  resetJoiningActivityListsState,
  callCreatedActivityListsAPI,
  resetCreatedActivityListsState,
  callCouponsAPI,
  countCouponsPage,
  resetCouponsState,
  callRedeemedCouponsAPI,
  countRedeemedCouponsPage,
  resetRedeemedCouponsState,
  callPostsAPI,
  countPostsPage,
  resetPostsState,
  callRedeemedSponsorsAPI,
  countRedeemedSoponsorsPage,
  resetRedeemedSponsorsState,
  callSponsorsAPI,
  countSoponsorsPage,
  resetSponsorsState,
  setSearch,
  countFollowing,
  countSubscripted,
} = appSlice.actions;

export default appSlice.reducer;